<div class="profile-container">
  <p-toast></p-toast>
  
  <div class="profile-header">
    <h1 class="profile-title">Mon Profil</h1>
    <p class="profile-subtitle">Gérez vos informations personnelles et votre sécurité</p>
  </div>

  <div class="profile-content">
    <!-- User Information Card -->
    <div class="profile-card user-info-card">
      <div class="card-header">
        <i class="pi pi-user"></i>
        <h2>Informations Personnelles</h2>
      </div>
      
      <div class="user-avatar-section">
        <div class="user-avatar">
          <span class="avatar-initials">{{ getUserInitials() }}</span>
        </div>
        <div class="user-details">
          <h3 class="user-name">{{ currentUser?.prenom }} {{ currentUser?.nom }}</h3>
          <p class="user-email">{{ currentUser?.email }}</p>
          <span class="user-role-badge" [style.background-color]="getRoleColor()">
            {{ getRoleBadge() }}
          </span>
        </div>
      </div>

      <div class="info-grid">
        <div class="info-item">
          <label>Prénom</label>
          <p>{{ currentUser?.prenom || 'Non renseigné' }}</p>
        </div>
        <div class="info-item">
          <label>Nom</label>
          <p>{{ currentUser?.nom || 'Non renseigné' }}</p>
        </div>
        <div class="info-item">
          <label>Email</label>
          <p>{{ currentUser?.email || 'Non renseigné' }}</p>
        </div>
        <div class="info-item">
          <label>Rôle</label>
          <p>{{ getRoleBadge() }}</p>
        </div>
        <div class="info-item" *ngIf="currentUser?.is_hubspot_user">
          <label>Compte HubSpot</label>
          <p class="hubspot-badge">
            <i class="pi pi-check-circle"></i>
            Connecté
          </p>
        </div>
      </div>
    </div>

    <!-- Password Change Card -->
    <div class="profile-card password-card">
      <div class="card-header">
        <i class="pi pi-lock"></i>
        <h2>Sécurité du Compte</h2>
      </div>

      <form [formGroup]="passwordForm" (ngSubmit)="onChangePassword()" class="password-form">
        <div class="form-group">
          <label for="currentPassword">Mot de passe actuel</label>
          <p-password 
            inputId="currentPassword"
            formControlName="currentPassword"
            [feedback]="false"
            [toggleMask]="true"
            placeholder="Entrez votre mot de passe actuel"
            styleClass="w-full"
            inputStyleClass="w-full">
          </p-password>
          <small class="error-message" *ngIf="passwordForm.get('currentPassword')?.invalid && passwordForm.get('currentPassword')?.touched">
            Le mot de passe actuel est requis
          </small>
        </div>

        <div class="form-group">
          <label for="newPassword">Nouveau mot de passe</label>
          <p-password 
            inputId="newPassword"
            formControlName="newPassword"
            [feedback]="true"
            [toggleMask]="true"
            placeholder="Entrez votre nouveau mot de passe"
            styleClass="w-full"
            inputStyleClass="w-full">
          </p-password>
          <small class="error-message" *ngIf="passwordForm.get('newPassword')?.invalid && passwordForm.get('newPassword')?.touched">
            Le mot de passe doit contenir au moins 6 caractères
          </small>
        </div>

        <div class="form-group">
          <label for="confirmPassword">Confirmer le mot de passe</label>
          <p-password 
            inputId="confirmPassword"
            formControlName="confirmPassword"
            [feedback]="false"
            [toggleMask]="true"
            placeholder="Confirmez votre nouveau mot de passe"
            styleClass="w-full"
            inputStyleClass="w-full">
          </p-password>
          <small class="error-message" *ngIf="passwordForm.errors?.['passwordMismatch'] && passwordForm.get('confirmPassword')?.touched">
            Les mots de passe ne correspondent pas
          </small>
        </div>

        <div class="form-actions">
          <button 
            pButton 
            type="submit" 
            label="Modifier le mot de passe"
            icon="pi pi-check"
            [loading]="isChangingPassword"
            [disabled]="passwordForm.invalid"
            class="submit-btn">
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
